import PlaceModel         from '@models/map/PlaceModel';
import currentEditorStore from '@/TokamapEditor/stores/currentEditorStore';
import shapePlaceId       from '@/TokamapEditor/helpers/shapePlaceId';
import unlinkPlaceContent from '@/TokamapEditor/helpers/unlinkPlaceContent';

/**
 * Dissocie de ce point d'intérêt les formes qui l'ouvrent, avant sa suppression. Hors historique,
 * comme `deleteShapesFromPlace` : un Ctrl+Z relierait la forme à un point d'intérêt disparu.
 */
export default async function unlinkShapesFromPlace(place: PlaceModel) {
	const editor = currentEditorStore.get;

	if (!editor) return;

	const shapes = editor.getAllShapes().filter(shape => shapePlaceId(shape) === String(place.id));

	if (!shapes.length) return;

	const ids = shapes.map(shape => shape.id);
	const options = { skipHistory: true };

	await unlinkPlaceContent(shapes, options);

	editor.setShapeEntity(ids, undefined, options);
	editor.setShapeAction(ids, undefined, options);
}
